'use strict';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ContaParcelaService } from '../shared/conta-parcela.service';

import { ConfirmDialogComponent } from '../../core/dialogs/confirm-dialog/confirm-dialog.component';
import { InfoDialogComponent } from '../../core/dialogs/info-dialog/info-dialog.component';

import { AnexoComponent } from 'src/app/anexo/anexo/anexo.component';
import { ContaCorrenteVendaComponent } from 'src/app/conta-corrente/conta-corrente-venda/conta-corrente-venda.component';
import { OperacaoContabilService } from 'src/app/contabil/shared/operacao-contabil.service';
import { LogComponent } from 'src/app/log/log/log.component';
import { CaixaMovimentoComponent } from '../caixa-movimento/caixa-movimento.component';
import { ContaCadastroComponent } from '../conta-cadastro/conta-cadastro.component';
import { ContaParcelaBaixaComponent } from '../conta-parcela-baixa/conta-parcela-baixa.component';
import { ContaParcela, TipoPagamento } from '../shared/conta-parcela.model';
import { ContaService } from '../shared/conta.service';

import { AnexoService } from 'src/app/anexo/shared/anexo.service';
import { ContaCorrenteVendaService } from 'src/app/conta-corrente/shared/conta-corrente-venda.service';
import { ContaCorrenteService } from 'src/app/conta-corrente/shared/conta-corrente.service';
import { NfseCadastroComponent } from 'src/app/fiscal/nfse-cadastro/nfse-cadastro.component';
import { Nfse } from 'src/app/fiscal/shared/nfse.model';
import { NfseService } from 'src/app/fiscal/shared/nfse.service';
import { ContaParcelaSubstituicaoMapearComponent } from '../conta-parcela-substituicao-mapear/conta-parcela-substituicao-mapear.component';
import { CaixaService } from '../shared/caixa.service';
import { AcaoNotaFiscalSubstituicao, StatusNotaFiscalContaPagar } from '../shared/nota-fiscal-conta-pagar.model';
import { ContaParcelaSubstituicaoNotaFiscalComponent } from '../conta-parcela-substituicao-nota-fiscal/conta-parcela-substituicao-nota-fiscal.component';

/** StatusProcessamento da NFS-e cancelada (o mesmo do NfseService.corStatus). */
const StatusProcessamentoNfseCancelada = '101';

export interface DialogData {
  contaParcelaId: number;
  tpConta: number;
  contaId: number;
  apenasVisualiza: boolean;
}

@Component({
  selector: 'conta-parcela',
  templateUrl: 'conta-parcela.component.html',
  styleUrls: ['conta-parcela.component.css'],
  encapsulation: ViewEncapsulation.None,
})

export class ContaParcelaComponent {

  contaParcelaForm: FormGroup;
  maximizado: boolean;
  permiteEdicao: boolean = false;
  tipoOperacao: string = '';
  contaParcela: any = {};
  boleto: any = {};
  operacoesContabeis: any = [];
  layouBoleto: number = null;
  // O back-end decide (PermiteAlterarValorVencimento): boleto do Bradesco API não aceita alterar valor/vencimento.
  edicaoValorVencimentoBloqueada: boolean = false;
  nfse: Nfse;
  ultimoLog: any = {};
  public tipoPagamentoEnum = TipoPagamento;
  public opcoesTipoPagamento: { valor: number; texto: string }[] = [];
  isCartaoQuitado: boolean = false;
  permiteEditarDescricao: boolean = false;
  codigoAutenticacao: string = "";
  cartao: string = "";
  numeroComprovanteDeVenda = "";
  terminal: string = "";
  observacaoPagamento: string;
  arquivoNome: string;
  anexo: any;
  valorTaxa: number = 0;
  valorLiquido: number = 0;
  valorVenda: number = 0;
  caixaDescricao: string = '';
  podeSubstituir = false;
  /** NFS-e não cancelada (a receber) ou nota do fornecedor ativa (a pagar): a substituição pergunta o que fazer com ela. */
  possuiNotaFiscalAtiva = false;

  constructor(
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ContaParcelaComponent>,
    private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public IContaParcela: DialogData,
    private contaParcelaService: ContaParcelaService,
    public contaService: ContaService,
    private contaCorrenteService: ContaCorrenteService,
    private caixaService: CaixaService,
    private operacaoContabilService: OperacaoContabilService,
    private contaCorrenteVendaService: ContaCorrenteVendaService,
    private anexoService: AnexoService,
    public nfseService: NfseService) {
  }

  ngOnInit() {

    this.maximizado = false;

    this.contaParcelaForm = this._formBuilder.group(new ContaParcela());
    if (this.IContaParcela.apenasVisualiza === true) {
      this.contaParcelaForm.disable();
    }

    this.contaParcelaForm.get('contaId').setValue(this.IContaParcela.contaId);

    if (this.IContaParcela.contaParcelaId > 0) {

      this.buscarContaParcela(this.IContaParcela.contaParcelaId);

    } else {
      this.tipoOperacao = "Incluir";
      this.permiteEdicao = true; // se for operação de inclusão, permite edição
    }

    this.onChanges();

    this.restaurarDialog();

    this.carregarOpcoesPagamento();
  }



  onChanges(): void {

    this.contaParcelaForm
      .get('tipoPagamento')
      .valueChanges
      .subscribe(data => {
        if (data === 8) {
          this.contaParcelaForm.get('contaParcelaTipo').setValue(2);
          this.operacaoContabilService.getOperacoesContabeis().subscribe(data => {

            this.operacoesContabeis = data.body;

          }, (error: HttpErrorResponse) => {

            const dialogRef = this.dialog.open(InfoDialogComponent, {
              data: {
                titulo: "Erro",
                erro: error
              }
            });
          });

        } else {
          this.contaParcelaForm.get('contaParcelaTipo').setValue(this.IContaParcela.tpConta);
        }

      });

    // atualiza exibição das opções de pagamento ao alterar o status do pagamento
    this.contaParcelaForm.get('statusPagamento').valueChanges.subscribe(value => {
      this.carregarOpcoesPagamento();
    });
  }

  fecharDialog() {
    this.dialogRef.close();
  }

  maximizarDialog() {
    this.dialogRef.updateSize('100%', '100%');
    this.maximizado = true;
  }

  restaurarDialog() {

    let innerWidth = window.innerWidth;

    if (innerWidth < 1024) {
      this.dialogRef.updateSize('90%', '100vh');
    }
    else {
      this.dialogRef.updateSize('60%', '100vh');
    }
    this.maximizado = false;
  }


  visualizaNfse(contaParcela: any) {
    let id = contaParcela.nfseId;
    let contaParcelaDescricao = contaParcela.descricao;

    const dialogRef = this.dialog.open(NfseCadastroComponent, {
      data: {
        nfseId: id,
        discriminacao: contaParcelaDescricao
      },
      maxHeight: '100vh'
    });

    dialogRef.afterClosed().subscribe(result => {

      this.buscarContaParcela(contaParcela.contaParcelaId);

    });

  };

  buscarContaParcela(contaParcelaId: number) {

    this.tipoOperacao = "Atualizar";
    if (this.IContaParcela.apenasVisualiza === true)
      this.tipoOperacao = "Dados da"

    this.contaParcelaService.getContaParcela(contaParcelaId).subscribe(data => {

      this.contaParcelaForm.patchValue(data.body);
      this.contaParcela = data.body;
      this.edicaoValorVencimentoBloqueada = this.contaParcela.permiteAlterarValorVencimento === false;

      const podeSubstituirPeloStatus = this.contaParcela.statusPagamento !== 1   // quitada
        && this.contaParcela.statusPagamento !== 6;  // substituída

      // "Substituir" só aparece depois de saber se a parcela tem nota ativa: é isso que decide se a
      // substituição pergunta o que fazer com a nota. Antes disso, o clique cancelaria a nota sem perguntar.
      this.podeSubstituir = false;
      this.possuiNotaFiscalAtiva = false;

      // a nota do fornecedor (conta a pagar) só vem no endpoint próprio; a NFS-e, no bloco abaixo
      const temNotaDoFornecedor = this.IContaParcela.tpConta == 1 && data.body.notaFiscalContaAPagarId > 0;

      if (temNotaDoFornecedor) {
        this.contaParcelaService.getNotaFiscalContaAPagar(contaParcelaId).subscribe(resposta => {
          this.possuiNotaFiscalAtiva = resposta.body.notaFiscal?.status === StatusNotaFiscalContaPagar.Ativa;
          this.podeSubstituir = podeSubstituirPeloStatus;
        });
      } else if (!(data.body.nfseId > 0)) {
        this.podeSubstituir = podeSubstituirPeloStatus;
      }

      this.buscarAnexos(data.body)

      this.buscarCaixa(data.body.caixaId);

      this.preencheDadosCartao();

      this.retornaStatusPagamento(this.contaParcela.statusPagamento);

      if (data.body.nfseId > 0) {
        this.contaParcelaService.getVisualizaNfsePorContaParcela(this.contaParcela.nfseId).subscribe(data => {
          this.nfse = data.body;

          if (!temNotaDoFornecedor) {
            this.possuiNotaFiscalAtiva = this.nfse?.statusProcessamento !== StatusProcessamentoNfseCancelada;
            this.podeSubstituir = podeSubstituirPeloStatus;
          }
        })
      }

      if (data.body.boletoId > 0) {

        let parcelas = [];

        let _parcela = data.body;

        let _conta = {
          contaId: _parcela.contaId,
          tpConta: this.IContaParcela.tpConta,
        };

        _parcela.conta = _conta;

        parcelas.push(data.body);

        let boletoIds: any = [];

        parcelas.forEach(parcela => {
          boletoIds.push(parcela.boletoId);
        })

        this.getUltimoLogBoleto(_parcela.boletoId);



        this.contaService.postVisualizaBoletoPorContaParcela(boletoIds).subscribe(boletoResult => {

          this.boleto = boletoResult.body[0];

        }, (error: HttpErrorResponse) => {

          const dialogRef = this.dialog.open(InfoDialogComponent, {
            data: {
              titulo: "Erro",
              erro: error
            }
          });
        });

      }

      this.contaCorrenteService.getContaCorrente(data.body.contaCorrenteId).subscribe(data => {
        this.layouBoleto = data.body.contaCorrenteTipoArquivo;
      })

    }, (error: HttpErrorResponse) => {

      const dialogRef = this.dialog.open(InfoDialogComponent, {
        data: {
          titulo: "Erro",
          erro: error
        }
      });
    })
  }

  salvar(): void {

    if (this.tipoOperacao == "Incluir") {

      this.contaParcelaForm.get('dataCriacao').setValue(new Date());

      this.contaParcelaService.postContaParcela(this.contaParcelaForm.value).subscribe(data => {

        this._snackBar.open("Registro Salvo com Sucesso");

        this.fecharDialog();

      });

    }
    else if (this.permiteEditarDescricao) {

      // parcela quitada: envia apenas a descrição, sem movimentar o fluxo de caixa
      const form = this.contaParcelaForm.getRawValue();
      const alterarDescricao = { contaParcelaId: form.contaParcelaId, descricao: form.descricao };

      this.contaParcelaService.putContaParcelaAlterarDescricao(this.contaParcela.contaParcelaTipo, alterarDescricao).subscribe(data => {
        this._snackBar.open("Registro Salvo com Sucesso");
        this.fecharDialog();
      }, (error: HttpErrorResponse) => {

        const dialogRef = this.dialog.open(InfoDialogComponent, {
          data: {
            titulo: "Erro",
            erro: error
          }
        });
      });
    }
    else {
      const form = this.contaParcelaForm.value;


      // Verifica se os campos sensíveis foram alterados
      const camposAlterados =
        this.contaParcelaForm.get('valorParcela').value !== this.contaParcela.valorParcela ||
        this.contaParcelaForm.get('dataVencimento').value !== this.contaParcela.dataVencimento;

      const boletoGerado = form.boletoId > 0;
      const boletoCNAB = !(this.layouBoleto === 2);
      const boletoAtivo = this.boleto.status === 0 || this.boleto.status === 5 || this.boleto.status === 6 || this.boleto.status === 8 || this.boleto.status === 9;


      if (boletoGerado && boletoCNAB && camposAlterados && boletoAtivo) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          data: {
            titulo: '⚠️ ATENÇÃO',
            mensagem: "Já existe um boleto gerado para essa conta-parcela. Ao continuar com a edição, o boleto atual será cancelado e um novo será gerado. Deseja continuar?"
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.contaParcelaService.putContaParcela(form.contaParcelaId, form).subscribe(data => {
              this._snackBar.open("Registro Salvo com Sucesso");
              this.fecharDialog();
            });
          }
        });
      } else {
        this.contaParcelaService.putContaParcela(form.contaParcelaId, form).subscribe(data => {
          this._snackBar.open("Registro Salvo com Sucesso");
          this.fecharDialog();
        });
      }
    }

  }

  corrigirParcela() {

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        titulo: "Corrigir",
        mensagem: "Essa opção apenas irá corrigir a parcela e não irá movimentar o fluxo de caixa. Caso deseje movimentar o fluxo de caixa clique no botão Salvar ao invés do botão Corrigir Parcela. Deseja continuar?"
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.contaParcelaService.putContaParcelaCorrigir(this.contaParcelaForm.value.contaParcelaId, this.contaParcelaForm.value).subscribe(data => {

          const dialogRef = this.dialog.open(InfoDialogComponent, {
            data: {
              titulo: "Sucesso",
              mensagem: "Registro Corrigido com Sucesso"
            }
          });

        }, (error: HttpErrorResponse) => {

          const dialogRef = this.dialog.open(InfoDialogComponent, {
            data: {
              titulo: "Erro",
              erro: error
            }
          });
        });
      }
    });

  };

  abreModalConta(contaId) {

    const dialogRef = this.dialog.open(ContaCadastroComponent, {
      data: {
        contaId: contaId,
        tpConta: this.IContaParcela.tpConta,
        tipoParceiro: 0
      },
      maxHeight: '100vh',
      maxWidth: '100vw'
    });

    this.fecharDialog();

  };

  abreModalAnexo() {

    const formData = this.contaParcelaForm.getRawValue();

    const dialogRef = this.dialog.open(AnexoComponent, {
      data: {
        documentoIdReferenciado: formData.contaParcelaId,
        documentoTipo: formData.contaParcelaTipo === 0 ? 10 : 11, // se for conta a receber(10) a pagar (11)
        saguiClienteId: formData.saguiClienteId
      },
      maxHeight: '100vh',
      maxWidth: '100vw'
    });
  }

  abrirLogs() {
    console.log(this.IContaParcela);
    const dialogRef = this.dialog.open(LogComponent, {
      data: {
        entidadeId: this.IContaParcela.contaParcelaId,
        logTipo: 0
      },
      maxHeight: '100vh',
      maxWidth: '100vw'
    });

  }

  definirComoPago() {

    if (this.contaParcelaForm.value.statusPagamento == 1)

      if (this.contaParcelaForm.value.valorPagamento == 0) {

        this.contaParcelaForm.get('valorPagamento').setValue(this.contaParcelaForm.value.valorParcela);

      }

    if (
      this.contaParcelaForm.get('dataPagamento').value == undefined ||
      this.contaParcelaForm.get('dataPagamento').value == null) {

      let dataAtual = new Date();
      this.contaParcelaForm.get('dataPagamento').setValue(dataAtual);

    }
  }

  caixaMovimentoModal() {

    const dialogRef = this.dialog.open(CaixaMovimentoComponent, {
      data: {
        caixaMovimentoId: this.contaParcelaForm.value.caixaMovimentoId,
        caixaId: this.contaParcelaForm.value.caixaId,
      },
      maxHeight: '100vh',
      maxWidth: '100vw'
    });
  };

  contaCorrenteVendaModal(contaCorrenteVendaId: number) {

    const dialogRef = this.dialog.open(ContaCorrenteVendaComponent, {
      data: {
        contaCorrenteVendaId: contaCorrenteVendaId,
      },
      maxHeight: '100vh',
      maxWidth: '100vw'
    });
  }

  // define o modo de edição pelo status que veio do back: permiteEdicao e permiteEditarDescricao nunca ficam true ao mesmo tempo
  retornaStatusPagamento(statusPagamento: number) {

    switch (statusPagamento) {
      case 0:
        this.permiteEdicao=true;
        this.permiteEditarDescricao=false;
        break;
      case 1:
        // quitada: bloqueia todos os campos, mantendo apenas a descrição editável
        this.permiteEdicao=false;
        this.permiteEditarDescricao=true;
        this.contaParcelaForm.disable();
        this.contaParcelaForm.get('descricao').enable();
        break;
      case 2:
        this.permiteEdicao=false;
        this.permiteEditarDescricao=false;
        break;
      default:
        this.permiteEdicao=false;
        this.permiteEditarDescricao=false;
        break;
    }
  }

  baixarParcela(contaParcelaId: number, numeroParcelas: number) {

    const dialogRef = this.dialog.open(ContaParcelaBaixaComponent, {
      data: {
        contaParcelaId: contaParcelaId,
        sugestaoParcelas: numeroParcelas,
      },
      maxHeight: '100vh',
      maxWidth: '100vw'
    });

    dialogRef.afterClosed().subscribe(result => {

      this.buscarContaParcela(contaParcelaId);

    });

  };

  cancelarParcela(cancelarContaParcelas) {

    let parcelas = [];

    parcelas.push(cancelarContaParcelas);

    this.cancelarParcelas(parcelas);
  };


  getUltimoLogBoleto(boletoId: number) {
    this.contaParcelaService.getUltimoLogBoleto(boletoId).subscribe(data => {

      this.ultimoLog = data.body;
    })
  }

  cancelarParcelas(cancelarContaParcelas) {

    let msg = "Deseja cancelar esta(s) parcela(s)?"

    if (cancelarContaParcelas.some(x => x.statusPagamento == 1)) {
      msg += " Isso também excluirá os registros correspondentes no fluxo de caixa."
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        titulo: "Confirmação",
        mensagem: msg
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.contaParcelaService.postCancelarContaParcelas(cancelarContaParcelas).subscribe(data => {

          const dialogRef = this.dialog.open(InfoDialogComponent, {
            data: {
              titulo: "Sucesso",
              mensagem: "Registro Cancelado com Sucesso"
            }
          });

          this.buscarContaParcela(this.IContaParcela.contaParcelaId);

        }, (error: HttpErrorResponse) => {

          const dialogRef = this.dialog.open(InfoDialogComponent, {
            data: {
              titulo: "Erro",
              erro: error
            }
          });
        });
      }
    });
  };


  carregarOpcoesPagamento(): void {

    // se o status for pago (1), carrega todas as opções
    if (this.contaParcelaForm.get('statusPagamento').value == 1) {
      this.opcoesTipoPagamento = this.contaParcelaService.carregarOpcoesPagamento();
      // se o status for a pagar (0), filtra a opção BolePix
    } else if (this.contaParcelaForm.get('statusPagamento').value == 0) {
      this.opcoesTipoPagamento = this.contaParcelaService.carregarOpcoesPagamento().filter(op => op.valor !== TipoPagamento['BolePix']);
    }
  }

  retornaPagamentoSelecionado(opção) {
    let pagamento = this.opcoesTipoPagamento.find(x => x.valor == opção);

    if (pagamento)
      return pagamento.texto

    return "Não informado"
  }

  exibirDadosCartaoQuitado() {

    // se não vier status pagamento ou tipo de pagamento já nçao vai exibir dados do cartão
    if (this.contaParcelaForm.get('statusPagamento').value == null || this.contaParcelaForm.get('tipoPagamento').value == null) {
      this.isCartaoQuitado = false;
    }

    // se status pagamento for quitado (1) e tipo de pagamento for credito(1) ou debito (2) exibe informações
    if (this.contaParcelaForm.get('statusPagamento').value == 1 &&
      (this.contaParcelaForm.get('tipoPagamento').value == 1 || this.contaParcelaForm.get('tipoPagamento').value == 2)) {
      this.isCartaoQuitado = true;
    }

    return this.isCartaoQuitado;
  }

  preencheDadosCartao() {
    if (this.exibirDadosCartaoQuitado() && this.contaParcela.contaCorrenteVendaId > 0) {
      this.contaParcelaService.getDadosVendaCartao(this.contaParcela.contaCorrenteVendaId).subscribe(data => {
        this.terminal = data.body.terminal ?? "Não informado";
        this.codigoAutenticacao = data.body.codigoAutenticacao ?? "Não informado";
        this.numeroComprovanteDeVenda = data.body.numeroComprovanteDeVenda ?? "Não informado";
        this.cartao = data.body.cartao ?? "Não informado";
        this.valorLiquido = data.body.valorLiquido;
        this.valorTaxa = data.body.valorTaxa;
        this.valorVenda = data.body.valorVenda;

      })
    }
  }

  buscarCaixa(caixaId: number) {

    if (!(caixaId > 0)) {
      this.caixaDescricao = '';
      return;
    }

    this.caixaService.getCaixa(caixaId).subscribe(data => {

      let caixa = data.body;

      this.caixaDescricao = [caixa?.nome, caixa?.descricao].filter(x => x).join(' - ');

    });
  }

  buscarAnexos(contaParcela: any) {
    let documentoTipo;
    if (contaParcela.contaParcelaTipo === 0) {
      documentoTipo = 10;
    } else {
      documentoTipo = 11;
    }
    this.anexoService.postVisualizaAnexoPorFiltro(
      { documentoIdReferenciado: contaParcela.contaParcelaId, documentoTipo: documentoTipo }
    ).subscribe(data => {
      let anexoMaisRecente;
      let anexos = data.body;
      if (anexos.length > 0) {
        anexoMaisRecente = anexos.reduce((maisRecente, atual) =>
          new Date(atual.dataCriacao) > new Date(maisRecente.dataCriacao) ? atual : maisRecente
        );
      }
      if (anexoMaisRecente) {
        this.arquivoNome = anexoMaisRecente.nomeArquivo;
        this.anexo = anexoMaisRecente;
      }
    });
  }

  baixarAnexo() {
    this.anexoService.download(this.anexo);
  }

  abrirBoleto() {

  }

  confirmarSubstituicao() {
    if (!this.permiteSubstituicao())
      return;

    // Com nota ativa, o usuário escolhe se a nota vai para a parcela nova ou é cancelada.
    if (this.possuiNotaFiscalAtiva) {
      this.dialog.open(ContaParcelaSubstituicaoNotaFiscalComponent, {
        data: {
          tpConta: this.IContaParcela.tpConta,
          textoDestino: 'a parcela nova'
        }
      }).afterClosed().subscribe((acaoNotaFiscal: AcaoNotaFiscalSubstituicao) => {
        if (acaoNotaFiscal) {
          this.substituirPorNova(acaoNotaFiscal);
        }
      });

      return;
    }

    const detalhe = this.IContaParcela.tpConta == 0 ?
      "Os boletos e/ou notas fiscais associados à parcela atual serão cancelados." :
      "A conta a pagar atual será substituída."

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        titulo: '⚠️ ATENÇÃO',
        mensagem: `Ao substituir esta parcela, a parcela atual será substituída por uma nova. ${detalhe} Deseja continuar?`
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.substituirPorNova(AcaoNotaFiscalSubstituicao.Cancelar);
      }
    })
  }

  private substituirPorNova(acaoNotaFiscal: AcaoNotaFiscalSubstituicao) {

    this.contaParcelaService.substituirPorNova(this.IContaParcela.tpConta, this.IContaParcela.contaParcelaId, acaoNotaFiscal).subscribe(data => {

      const resultado = data.body;
      const contaParcelaSubstitutaId = resultado.contaParcelaSubstitutaId;

      const abrirNovaParcela = () => {
        const dialogRef = this.dialog.open(ContaParcelaComponent, {
          data: {
            contaParcelaId: contaParcelaSubstitutaId,
            tpConta: this.IContaParcela.tpConta,
          },
          maxHeight: '100vh',
          maxWidth: '100vw'
        });

        dialogRef.afterClosed().subscribe(() => {
          this.buscarContaParcela(this.IContaParcela.contaParcelaId);
        });
      };

      if (resultado.avisos?.length > 0) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            titulo: '⚠️ ATENÇÃO',
            mensagem: resultado.avisos.join('\n')
          }
        }).afterClosed().subscribe(() => abrirNovaParcela());
      } else {
        abrirNovaParcela();
      }
    });
  }

  mapearSubstituicao() {
    if (!this.permiteSubstituicao())
      return;

    const dialogRef = this.dialog.open(ContaParcelaSubstituicaoMapearComponent, {
      data: {
        contaParcelaId: this.IContaParcela.contaParcelaId,
        tpConta: this.IContaParcela.tpConta,
        possuiNotaFiscalAtiva: this.possuiNotaFiscalAtiva,
      },

      minHeight: '45%',
      maxHeight: '100vh',
      maxWidth: '100%',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.buscarContaParcela(this.IContaParcela.contaParcelaId);
      }
    });
  }

  permiteSubstituicao() {
    // se status de contaParcela for igual a quitada ou substituida não permite substituição
    if (this.contaParcelaForm.get("statusPagamento")?.value === 1 ||
      this.contaParcelaForm.get("statusPagamento")?.value === 6) {
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        data: {
          titulo: 'Erro',
          mensagem: 'Não é possível substituir uma conta parcela substituída ou quitada.',
        },
      });

      return false;
    }

    return true;
  }

}
